module.exports = __webpack_public_path__ + "static/media/Telegram.bb70b6ce.svg";